import BaseClass from './BaseClass'
import axios from '../axios'

export default class Shopify_Publications extends BaseClass {
    constructor() {
        super('api/shopify/publications/')
    }

    async list(page = 1, page_size = 50, filtros = {}) {
        let busqueda = filtros.busqueda ?? '';
        delete filtros.busqueda;
        delete filtros.page;
        delete filtros.step;
        delete filtros.filter;
        
        if (Object.values(filtros).every(x => x === null || x === '')) {
            const res = await axios.get(`${this.urlBase}?page=${page}&size=${page_size}&search=${busqueda}`);
            return res;
        } else {
            const res = await axios.post(`${this.urlBase}q?page=${page}&size=${page_size}&search=${busqueda}`, filtros);
            return res;
        }
    }

    async get(id) {
        const res = await axios.get(`${this.urlBase}${id}`);
        return res;
    }

    async delete(id) {
        const res = await axios.delete(`${this.urlBase}${id}`);
        return res;
    }
}

